module.exports = __webpack_public_path__ + "static/media/dtmf-1.d72dbc88.mp3";